(function() {
  "use strict";

  angular
    .module("app")
    .controller("CommunitiesListController", [
      "$scope",
      CommunitiesListController
    ]);

  function CommunitiesListController($scope) {
    $scope.sortList = function(indicator, isReverse) {
      $scope.sorting.indicatorId = indicator;
      $scope.sorting.indicator = "indicators[" + indicator + "].value";
      $scope.sorting.reverse = isReverse;
    };

    $scope.isActiveSortingDirection = function(indicatorId, isReverse) {
      return (
        $scope.sorting.indicatorId === indicatorId &&
        $scope.sorting.reverse === isReverse
      );
    };

    $scope.state.selectedCommunities.checkForUserSelections();
  }
})();
